import { useTranslation } from "react-i18next";

const Content = () => {
  const { t } = useTranslation();
  return (
    <p className="text-gray-0 body-14px-regular px-5 my-3">
      <span className="text-gray-4 body-14px-medium ml-2">
        {t("card-page.help")}:
      </span>
      {t("card-page.help-content")}
    </p>
  );
};
export default Content;
